import { alertConstants } from '../constants';

import SkyNotification from 'components/Notifications/SkyNotification.jsx';

export const alertActions = {
    clear,
    error,
    success,
    warning
};

function clear() {
    return { type: alertConstants.CLEAR };
}


function error(message) {
    let newMessage;

    if (Array.isArray(message.errors)) {
        message.errors.forEach(error => {
            SkyNotification.alertError(error)
        });
    }
    else {
        if (typeof message === 'string') newMessage = message;
        else if (message.message) newMessage = message.message;
        else message = 'Error during request, please contact Administrator'
        SkyNotification.alertError(newMessage);
    }

    return { type: alertConstants.ERROR, newMessage };
}
// function error(message) {
//     let newMessage;

//     if (Array.isArray(message)) {
//         message.forEach(error => {
//             if (error.message) SkyNotification.alertError(`${error.field}: ${error.message}`)
//             else if (error.type) SkyNotification.alertError(`${error.field}: ${error.type}`)

//         });
//     }
//     else {
//         if (typeof message === 'string') newMessage = message;
//         else if (message.message) newMessage = message.message;
//         else message = 'Error during request, please contact Administrator'
//         SkyNotification.alertError(newMessage);
//     }

//     return { type: alertConstants.ERROR, newMessage };
// }

function success(message) {
    let newMessage;
    if (typeof message === 'string') newMessage = message;
    else if (message.message) newMessage = message.message;
    else message = 'Error during request, please contact Administrator'
    SkyNotification.alertSuccess(newMessage);

    return { type: alertConstants.SUCCESS, newMessage };
}

function warning(message) {
    let newMessage;
    if (typeof message === 'string') newMessage = message;
    else if (message.message) newMessage = message.message;
    else message = 'Error during request, please contact Administrator'
    SkyNotification.alertWarning(newMessage);

    return { type: alertConstants.WARNING, newMessage };
}
